import React from "react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { roadmapSteps } from "../../data/framework";
export function RoadmapSection() {
  return <section className="w-full bg-navy-900 px-5 py-16 sm:py-24" data-id="element-335" data-mp="2fj50lycql0wy">
      <div className="mx-auto max-w-6xl" data-id="element-336" data-mp="2fg91w7t2e87g">
        <SectionHeading dark eyebrow="The Clinical Transformation" title="Organize Your Self-Ligating Treatment Planning Through 6 Clear Clinical Stages" data-id="element-337" data-mp="2aj938hyjo7qd" />

        <p className="mt-10 text-center text-sm font-extrabold uppercase tracking-[0.16em] text-sky" data-id="element-338" data-mp="2kihv959unca3">
          The Self-Ligating Clinical Roadmap
        </p>

        <ol className="relative mx-auto mt-8 grid max-w-5xl gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-339" data-mp="2yaxqvl0f880z">
          {roadmapSteps.map(step => <li key={step.number} className="flex gap-4 rounded-2xl border border-white/10 bg-navy-800 p-5" data-id="element-340" data-mp="386hoqcyjpgsd">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gold text-lg font-black text-navy-900" data-id="element-341" data-mp="3399507xr14p0">
                {step.number}
              </span>
              <div data-id="element-342" data-mp="28hvv3qmawet">
                <h3 className="text-xl font-black tracking-wide text-white" data-id="element-343" data-mp="2a2rkwoo4le9">{step.title}</h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-white/75" data-id="element-344" data-mp="77l04lyrwylq">{step.text}</p>
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-345" data-mp="g92g84c6l0af">
          <p className="text-xl font-black text-white sm:text-2xl" data-id="element-346" data-mp="g8slk3g6y4ye">One organized educational framework. Six connected stages.</p>
          <p className="mt-4 text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-347" data-mp="pyvnit5ait8v">
            The goal isn't to replace your clinical judgment.{" "}
            <span className="font-bold text-gold" data-id="element-348" data-mp="uwng7pdreje4">It's to help you organize the information your clinical judgment depends on.</span>
          </p>
        </div>

        <SectionCta dark label="I Want the Complete Clinical Roadmap" data-id="element-349" data-mp="13ydglkpmcso1" />
      </div>
    </section>;
}